/* eslint-disable react-hooks/exhaustive-deps */
import images from 'assets/images-base';
import ImageError from 'components/common/image-error/ImageError';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  FixButton,
  PaddingModalSearch,
  StyleAvatarSearch,
  StyleDivTitle,
  StyleMarginQuickSearch,
} from '../component/styled';

interface Props {
  title?: string;
  listApi?: any;
  className?: string;
  onclick?: any;
  active: number | null;
}
const ListQuickSearch: React.FC<Props> = ({ title, listApi, className, active }) => {
  const navigation = useNavigate();

  useEffect(() => {
    const listener = (event: any) => {
      if (event.code === 'Enter' || event.code === 'NumpadEnter') {
        const findElement = active ? listApi[active - 1] : null;
        if (findElement && active) {
          navigation(`/home/profile/${findElement.user_id}`);
        }
        event.preventDefault();
      }
    };
    document.addEventListener('keydown', listener);
    return () => {
      document.removeEventListener('keydown', listener);
    };
  }, [active]);

  return (
    <PaddingModalSearch>
      <StyleDivTitle>{title}</StyleDivTitle>
      <div>
        {listApi?.map((e: any, index: number) => {
          return (
            <StyleMarginQuickSearch key={e.user_id}>
              <div className={`${active && active === index + 1 ? 'bg-gray' : 'box-image-search-fast'}`}>
                {e.avatar == null ? (
                  <StyleAvatarSearch src={images.profile.avatarDefault} />
                ) : (
                  <ImageError
                    style={{ borderRadius: '50%', padding: '0' }}
                    width={34.17}
                    height={34.17}
                    src={e?.avatar_image || e?.avatar}
                  />
                )}{' '}
                <FixButton
                  onClick={() => {
                    navigation(`/home/profile/${e.user_id}`);
                  }}
                  className={className}
                  type="text"
                >
                  {' '}
                  {e?.name || e?.title}{' '}
                </FixButton>
              </div>
            </StyleMarginQuickSearch>
          );
        })}
      </div>
    </PaddingModalSearch>
  );
};
export default ListQuickSearch;
